import { Role } from './roles'

export const PlnViewRoles = [
  Role.ADMIN,
  Role.PLANNING_SUPERVISOR,
  Role.PLANNING_OFFICER,
  Role.PURCHASE_SUPERVISOR,
  Role.PURCHASE_OFFICER,
  Role.WAREHOUSE_SUPERVISOR,
  Role.WAREHOUSE_OFFICER,
  Role.QC_SUPERVISOR,
  Role.QC_OFFICER,
  Role.PRODUCTION_SUPERVISOR,
  Role.PRODUCTION_TECHNICIAN,
  Role.PRODUCTION_OFFICER,
  Role.SALES_SUPERVISOR,
  Role.SALES_OFFICER,
  Role.ACCOUNTING_SUPERVISOR,
  Role.ACCOUNTING_OFFICER,
  Role.QSS_OFFICER,
]

export const PlnModifyRoles = [
  Role.ADMIN,
  Role.ADMIN_CKD,
  Role.PLANNING_SUPERVISOR,
  Role.PLANNING_OFFICER,
]

export const PlnReportRoles = [
  Role.ADMIN,
  Role.PLANNING_SUPERVISOR,
  Role.PLANNING_OFFICER,
  Role.PURCHASE_SUPERVISOR,
  Role.WAREHOUSE_SUPERVISOR,
  Role.QC_SUPERVISOR,
  Role.PRODUCTION_SUPERVISOR,
  Role.SALES_SUPERVISOR,
  Role.ACCOUNTING_SUPERVISOR,
  Role.QSS_OFFICER,
]
